import { MyAccountPopoverMyBTProps } from "@routes/MyAccount/utils/types";

/**
 * MyAccount Login Profile Component used as profile icon in MyAccount Popover
 * Figma: https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3623-19440&t=XsTPoO6b0V5zVeJ1-4
 */
const MyAccountLoginProfile = ({
  firstCharOfLogin,
}: MyAccountPopoverMyBTProps): React.ReactElement => {
  return (
    <>
      <div
        data-testid="my-account-profile-red-dot"
        className="absolute -right-1 top-0 h-1 w-1 rounded-full bg-red"
      />

      <p className="font-poppins text-lg">{firstCharOfLogin}</p>
    </>
  );
};

export default MyAccountLoginProfile;
